import React from 'react';

import { Icon } from 'Components/frameworks/icon/Icon';
import { ICONS } from 'Components/utils/icon/icons';

import { t } from 'Src/i18n';

export const PaidBankingFormContent = () => {
  return (
    <div className="flex items-center">
      <Icon className="mr-10 text-green" name={ICONS.SMALL_CIRCLE_CHECK} width="2em" />
      <div className="text-3xl mt-0 font-brand text-saffron">
        {t('booking.partners.participants.multiGM.bookingConfirmed')}
      </div>
    </div>
  );
};
